import { useModals } from 'almanac-ui/Modal'
import useResponsiveDesign from './useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { IntegrationsDrawer } from 'components/ArticlePostPreview/PostPreviewBody/IntegrationsDrawer/IntegrationsDrawer'
import { IntegrationsModal } from 'components/IntegrationsModal/IntegrationsModal'
import { useCallback } from 'react'
import { useCustomHistory } from './useHistory'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { generatePath } from 'react-router-dom'
import { AUTOPILOT_INTEGRATIONS_PATH } from 'paths'

export const useOpenIntegrations = () => {
  const { openModal, closeAllModals } = useModals()
  const { isMobile } = useResponsiveDesign()
  const drawersStore = useRootStore().drawersStore
  const history = useCustomHistory()
  const workspace = useCurrentWorkspace()

  const openIntegrations = useCallback(() => {
    if (isMobile) {
      drawersStore.openDrawer(IntegrationsDrawer, {})
      return
    }

    // For virtual marketer workspaces, redirect to integrations page
    if (workspace?.is_virtual_marketer) {
      const integrationsPath = generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId: workspace.id })
      closeAllModals()
      // Use custom history to bypass HashRouter context (e.g., in brand-kits page)
      history.push(integrationsPath)
      return
    }

    openModal(IntegrationsModal)
  }, [drawersStore, isMobile, openModal, history, workspace, closeAllModals])

  return openIntegrations
}
